import { memo } from "react";
import { CSSTransition } from "react-transition-group";
import { Notification } from "../notification";
import { TRANSITION_TIMEOUT, TRANSITION_CLASS_NAMES } from "./constants";
import { NotificationsListProps } from "./types";

export const NotificationsList = memo(
  ({ notifications }: NotificationsListProps) => (
    <>
      {notifications.map(
        ({
          config,
          content,
          visible,
          notificationId,
          closeNotification,
          removeNotification,
        }) => {
          const { timeout, type, onClick, onExit, onClose } = config;

          const handleExited = () => {
            removeNotification?.(notificationId);
            onExit?.();
          };

          return (
            <CSSTransition
              appear
              mountOnEnter
              unmountOnExit
              in={visible}
              key={notificationId}
              timeout={TRANSITION_TIMEOUT}
              classNames={TRANSITION_CLASS_NAMES}
              onExited={handleExited}
            >
              <Notification
                key={notificationId}
                type={type}
                timeout={timeout}
                content={content}
                onClick={onClick}
                onClose={onClose}
                notificationId={notificationId}
                closeNotification={closeNotification}
              />
            </CSSTransition>
          );
        }
      )}
    </>
  )
);
